import { render, staticRenderFns } from "./signSupplier.vue?vue&type=template&id=0644980c&scoped=true"
import script from "./signSupplier.vue?vue&type=script&lang=js"
export * from "./signSupplier.vue?vue&type=script&lang=js"
import style0 from "./signSupplier.vue?vue&type=style&index=0&id=0644980c&prod&scoped=true&lang=css"
import style1 from "./signSupplier.vue?vue&type=style&index=1&id=0644980c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0644980c",
  null
  
)

export default component.exports